import React from 'react';

const TaskTable = ({ 
    tasks, 
    activeTab, 
    isManager, 
    renderRow 
}) => {
    if (!tasks || tasks.length === 0) {
        return null;
    }

    const showApprovalColumn = (isManager && activeTab === 'assigned-to-me') || activeTab === 'assigned-by-me';
    const assignedColumnLabel = activeTab === 'assigned-by-me' ? 'Assigned To' : 'Assigned By';

    return (
        <table className="tasks-table">
            <thead>
                <tr>
                    <th className="th-actions-icons" aria-label="Actions"></th>
                    <th>Task ID</th>
                    <th>Title</th>
                    {activeTab === 'all-tasks' ? (
                        <>
                            <th>Assigned To</th>
                            <th>Assigned By</th>
                        </>
                    ) : (
                        <th>{assignedColumnLabel}</th>
                    )}
                    <th>Priority</th>
                    {showApprovalColumn && <th>Approval Status</th>}
                    <th>Status</th>
                    <th>Created</th>
                    <th>Due Date</th>
                </tr>
            </thead>
            <tbody>
                {tasks.map(task => renderRow(task))}
            </tbody>
        </table>
    );
};

export default TaskTable;
